var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataScale = function SvgDataScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data-scale_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 45.188,
    height: 37.188,
    x: 5.406,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#data-scale_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#data-scale_svg__c)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-scale_svg__d)",
    d: "M16 16a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M24 8.5h8a7.5 7.5 0 0 1 0 15h-8a7.5 7.5 0 0 1 0-15Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 45.188,
    height: 37.188,
    x: 5.406,
    y: 12.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#data-scale_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#data-scale_svg__f)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-scale_svg__g)",
    fillOpacity: 0.5,
    d: "M16 28a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-scale_svg__h)",
    fillOpacity: 0.25,
    d: "M16 28a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M24 20.5h8a7.5 7.5 0 0 1 0 15h-8a7.5 7.5 0 0 1 0-15Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 45.188,
    height: 37.188,
    x: 5.406,
    y: 24.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#data-scale_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#data-scale_svg__j)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-scale_svg__k)",
    fillOpacity: 0.2,
    d: "M16 40a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-scale_svg__l)",
    d: "M16 40a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M24 32.5h8a7.5 7.5 0 0 1 0 15h-8a7.5 7.5 0 0 1 0-15Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-scale_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 55a1 1 0 0 0 1 1h9a1 1 0 1 0 0-2H2v-8a1 1 0 1 0-2 0zm10.192-7.778a1 1 0 0 0-1.414-1.414l.707.707zM1 55l.707.707 8.485-8.485-.707-.707-.707-.707-8.485 8.485z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-scale_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 1.515a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H2v8a1 1 0 1 1-2 0zm10.192 7.778a1 1 0 0 1-1.414 1.414L9.485 10zM1 1.515l.707-.707 8.485 8.485-.707.707-.707.707L.293 2.222z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-scale_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 55a1 1 0 0 1-1 1h-9a1 1 0 1 1 0-2h8v-8a1 1 0 1 1 2 0zm-10.192-7.778a1 1 0 0 1 1.414-1.414l-.707.707zM55 55l-.707.707-8.485-8.485.707-.707.707-.707 8.485 8.485z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-scale_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 1.515a1 1 0 0 0-1-1h-9a1 1 0 1 0 0 2h8v8a1 1 0 1 0 2 0zM45.808 9.293a1 1 0 0 0 1.414 1.414L46.515 10zM55 1.515l-.707-.707-8.485 8.485.707.707.707.707 8.485-8.485z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "data-scale_svg__c",
    width: 45.188,
    height: 37.188,
    x: 5.406,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4492_28598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-scale_svg__f",
    width: 45.188,
    height: 37.188,
    x: 5.406,
    y: 12.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4492_28598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-scale_svg__j",
    width: 45.188,
    height: 37.188,
    x: 5.406,
    y: 24.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4492_28598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-scale_svg__m",
    width: 13,
    height: 13,
    x: -1,
    y: 45,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4492_28598",
    result: "effect2_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4492_28598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-scale_svg__n",
    width: 13,
    height: 13,
    x: -1,
    y: 0.515,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4492_28598",
    result: "effect2_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4492_28598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-scale_svg__o",
    width: 13,
    height: 13,
    x: 44,
    y: 45,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4492_28598",
    result: "effect2_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4492_28598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-scale_svg__p",
    width: 13,
    height: 13,
    x: 44,
    y: 0.515,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4492_28598",
    result: "effect2_dropShadow_4492_28598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4492_28598",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "data-scale_svg__b",
    transform: "translate(-5.406 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "data-scale_svg__e",
    transform: "translate(-5.406 -12.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 28a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "data-scale_svg__i",
    transform: "translate(-5.406 -24.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 40a8 8 0 0 1 8-8h8a8 8 0 1 1 0 16h-8a8 8 0 0 1-8-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "data-scale_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-scale_svg__d",
    x1: 28.75,
    x2: 28.75,
    y1: 8.235,
    y2: 34.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-scale_svg__g",
    x1: 28,
    x2: 28,
    y1: 27.1,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-scale_svg__k",
    x1: 28,
    x2: 28,
    y1: 39.1,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "data-scale_svg__h",
    width: 2.667,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#data-scale_svg__q",
    transform: "scale(.0026 .0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "data-scale_svg__l",
    width: 2.667,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#data-scale_svg__q",
    transform: "scale(.0026 .0039)"
  })))));
};
export default SvgDataScale;